import store from '@/store'
import globalVaribale from '@/utils/globalVariable'
const builtinAdminId = globalVaribale.defaultBuiltinAdminId

export default {
  /**
   * 递归处理多级菜单
   * @param {*} app
   * @param {*} rootPath
   * @param {*} rootRoutes
   * @param {*} childRoutes
   * @param {*} router
   */
  geneChildrenRouter: function (app, rootPath, rootRoutes, childRoutes, router) {
    const moduleAuthDetail = store.state.user.appAuthDetail[app].filter(item => item.path === rootPath)
    const rootmenu = rootRoutes.filter(item => item.path === rootPath)
    if (moduleAuthDetail && moduleAuthDetail.length === 1) {
      if (childRoutes && childRoutes instanceof Array) {
        const result = this.geneRecuTree(childRoutes, moduleAuthDetail[0].children)
        if (result.length !== 0) {
          rootmenu[0].children = result
          if (router) {
            router.addRoutes(rootmenu)
          }
        }
      }
    }
  },
  /**
   * 递归
   * @param {*} l
   * @param {*} r
   *  排除非菜单数据
   */
  geneRecuTree(l, r) {
    const result = []
    if (l && l instanceof Array) {
      l.forEach((vl, il) => {
        r.forEach((vr, ir) => {
          if ((vl.path === vr.path && vr.value !== 'false')) {
            if (vl.children && vl.children.length !== 0 && vr.children && vr.children.length !== 0) {
              vl.children = this.geneRecuTree(vl.children, vr.children)
            }
            result.push(vl)
          }
        })
      })
    }
    return result
  },
  /**
   * 递归1
   * @param {*} l menu
   * @param {*} r db
   *  排除非菜单数据
   */
  geneRecuTree_(l, r) {
    const result = []
    if (r && r instanceof Array) {
      l.forEach((vl) => {
        r.forEach((vr) => {
          if ((vl.path === vr.path && vr.value !== 'false')) {
            if (vl.children && vl.children.length !== 0 && vr.children && vr.children.length !== 0) {
              vl.children = this.geneRecuTree_(vl.children, vr.children)
            }
            result.push(vl)
          }
        })
      })
    }
    return result
  },
  /**
   * 递归2
   * @param {*} l menu
   * @param {*} r db
   *  排除非菜单数据
   */
  geneRecuMenu(l, r) {
    const result = []
    if (r && r instanceof Array) {
      r.forEach((vr) => {
        if ((vr.path === l.path && vr.value !== 'false')) {
          if (vr.children && vr.children.length !== 0 && l.children && l.children.length !== 0) {
            l.children = this.geneRecuTree_(l.children, vr.children)
          }
          result.push(l)
        }
      })
    }
    return result
  },
  /**
   * 获取应用菜单
   * @param {应用根菜单的路由path} moduleRootPath
   */
  getModuleMenu(moduleRootPath) {
    const allModuleMenu = store.state.user.authRoutes.filter(item => item.path === moduleRootPath)
    if (allModuleMenu && allModuleMenu.length !== 0) {
      return allModuleMenu[0].children
    }
    return []
  },
  /**
   * 获取Tab应用菜单权限
   * @param {应用根菜单的路由path} moduleRootPath
   */
  hasTabAuth(module, tabGroupPath) {
    const moduleAuth = store.state.user.appAuthDetail[module]
    const temp = recuHasTabAuth(moduleAuth, tabGroupPath)
    return !!temp
  },
  /**
   * 获取模块按钮权限
   * @param {模块名称} module
   * @param {权限组path} buttonGroupPath
   */
  hasButtonAuth(module, buttonGroupPath) {
    const moduleAuth = store.state.user.appAuthDetail[module]
    const loginUserId = store.state.user.loginUser.userId
    if (builtinAdminId === loginUserId) {
      return true
    }
    const temp = recuHasAuth(moduleAuth, buttonGroupPath)
    return !!temp
  },
  /**
   * 循环查找树满足条件,节点
   * @param {*} tree
   * @param {*} path
   */
  checkTreeHasNodeByKey(tree, prop, key) {
    var stark = []
    stark = stark.concat(tree)
    while (stark.length) {
      var temp = stark.shift()
      if (temp.children) {
        stark = temp.children.concat(stark)
      }
      if (key === temp[prop]) {
        return temp
      }
    }
  },
  setRediectPath(menu) {
    if (menu && menu.length) {
      menu.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
          v.redirect = v.children[0].path
          this.setRediectPath(v.children)
        }
      })
    } else if (menu.children && menu.children.length > 0) {
      menu.redirect = menu.children[0].path
      this.setRediectPath(menu.children)
    }
  }
}
/**
 * 循环查找满足条件的按钮
 * @param {*} tree
 * @param {*} path
 */
const recuHasAuth = (tree, path) => {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
    if (temp && path === temp.path && temp.type === 1 && temp.value !== 'false') {
      return temp
    }
  }
}
/**
 * 循环查找满足条件的Tab
 * @param {*} tree
 * @param {*} path
 */
const recuHasTabAuth = (tree, path) => {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
    if (temp && path === temp.path && temp.type === 0 && temp.value !== 'false') {
      return temp
    }
  }
}
